import { Component, input, InputSignal, output, OutputEmitterRef, ChangeDetectionStrategy } from '@angular/core';
import { MdsMessageComponent } from '@medpacesoftwaredevelopment/designsystem';

export type AlertData = {
    content: string;
    type: 'highlight' | 'information' | 'danger' | 'caution';
    dataCy: string;
};

@Component({
    selector: 'medpace-alert',
    standalone: true,
    imports: [MdsMessageComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './alert.component.html',
})
export class AlertComponent {
    public readonly dismissable: InputSignal<boolean> = input(false);
    public readonly content: InputSignal<string> = input.required();
    public readonly appearance: InputSignal<'highlight' | 'information' | 'danger' | 'caution'> = input('highlight');

    public readonly closeMessageEvent: OutputEmitterRef<void> = output();
}
